import { render, staticRenderFns } from "./BrandMediaTag.vue?vue&type=template&id=59cdb712&scoped=true&"
import script from "./BrandMediaTag.vue?vue&type=script&lang=ts&"
export * from "./BrandMediaTag.vue?vue&type=script&lang=ts&"
import style0 from "./BrandMediaTag.vue?vue&type=style&index=0&id=59cdb712&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cdb712",
  null
  
)

export default component.exports